import { Injectable } from '@angular/core';
import {
  AuthService,
  UserProfile,
  UserProfileConfigService,
} from '@openmfp/portal-ui-lib';

@Injectable({ providedIn: 'root' })
export class DxpUserProfileConfigService implements UserProfileConfigService {
  constructor(private authService: AuthService) {}

  async getProfile(): Promise<UserProfile> {
    const { userId } = this.authService.getUserInfo();

    return {
      logout: {
        label: 'PROFILE_SIGNOUT',
        icon: 'log',
      },
      items: [
        {
          label: 'PROFILE_PROFILE',
          icon: 'customer',
          link: `/users/${userId}/overview`,
        },
      ],
    };
  }
}
